import { SkillsDTO } from "./skills.dto";
import { Injectable } from "@nestjs/common";
import { Skills } from "../skills.entity";

@Injectable()
export class SkillsAdapter{

    public convertDtoToEntity(skillsDTO: SkillsDTO, isUpdate: boolean = false): Skills{
        const skillsEntity = new Skills();
        skillsEntity.skillsId= skillsDTO.skillsId
        skillsEntity.skills = skillsDTO.skills;
        skillsEntity.isActive = skillsDTO.isActive === undefined ? true : skillsDTO.isActive;
        if(isUpdate){
            skillsEntity.updatedUser = skillsDTO.updatedUser;
        }else{
            skillsEntity.isActive = true;
            skillsEntity.createdUser = skillsDTO.createdUser;
        }
        return skillsEntity;
    }

    public convertEntityToDto(skillsObj: Skills): SkillsDTO{
        const skillsDTO = new SkillsDTO;
        skillsDTO.skillsId= skillsObj.skillsId
        skillsDTO.skills = skillsObj.skills;
        skillsDTO.isActive = skillsObj.isActive;
        skillsDTO.createdAt = skillsObj.createdAt;
        skillsDTO.updatedAt = skillsObj.updatedAt;
        skillsDTO.updatedUser = skillsObj.updatedUser;
        skillsDTO.createdUser = skillsObj.createdUser;
        skillsDTO.versionFlag = skillsObj.versionFlag;
        return skillsDTO;

    }
}